import { useState, memo } from "react";
import { useTranslation } from "react-i18next";

import moreFilterOptionsIcon from "/assets/more-filter-options.svg";
import InlineSelect from "/components/InlineSelect";

const Filter = memo(({
  label,
  options,
  onChange,
  selectedOptions = [],
  initialOptionsAmount = 3,
}) => {
  const { t } = useTranslation();
  const [isAllOptionsVisible, setIsAllOptionsVisible] = useState(false);

  const handleShowMoreOptions = (event) => {
    event.preventDefault();

    setIsAllOptionsVisible(true);
  };

  const handleShowLessOptions = (event) => {
    event.preventDefault();

    setIsAllOptionsVisible(false);
  };

  const allOptionsAmount = Object.keys(options).length;
  const visibleOptions = isAllOptionsVisible ? Object.entries(options) : Object.entries(options).slice(0, initialOptionsAmount);

  const handleChange = (event, key) => {
    if (typeof onChange !== "function") return;

    let newValue;

    if (event.target.checked) {
      newValue = [...selectedOptions, key];
    } else {
      newValue = selectedOptions.filter(optionKey => optionKey !== key);
    }

    onChange(newValue);
  };

  const handleReset = (event) => {
    if (selectedOptions.length > 0) {
      onChange([]);
    } else {
      setIsAllOptionsVisible(true);
      onChange(Object.keys(options));
    }
  };

  const allOptionsAreSelected = selectedOptions.length === Object.keys(options).length;

  return (
    <>
      <div className="projects-filter--desktop">
        <label className="projects-filter__label">{label}</label>
        <ul className="projects-filter__options">
          <li key="all">
            <label className="chck__label">
              <input
                type="checkbox"
                className="chck"
                onClick={handleReset}
                checked={allOptionsAreSelected}
                readOnly={true}
              />
              {t("projects.filters.all")}
            </label>
          </li>

          {visibleOptions.map(([key, value]) => (
            <li key={key}>
              <label className="chck__label">
                <input
                  type="checkbox"
                  className="chck"
                  checked={selectedOptions.includes(key)}
                  onChange={(event) => handleChange(event, key)}
                />
                {value}
              </label>
            </li>
          ))}
        </ul>

        {(!isAllOptionsVisible && allOptionsAmount > initialOptionsAmount) && (
          <a
            className="projects-filter__more-options"
            href="#"
            onClick={handleShowMoreOptions}
          >
            {t("projects.filters.more", { amount: allOptionsAmount - initialOptionsAmount})} <img src={moreFilterOptionsIcon} />
          </a>
        )}

        {(isAllOptionsVisible && allOptionsAmount > initialOptionsAmount) && (
          <a
            className="projects-filter__more-options--less"
            href="#"
            onClick={handleShowLessOptions}
          >
            {t("projects.filters.less")} <img src={moreFilterOptionsIcon} />
          </a>
        )}
      </div>

      <div className="projects-filter--mobile">
        <InlineSelect
          label={label}
          options={options}
          onChange={onChange}
          selectedOptions={selectedOptions}
        />
      </div>
    </>
  );
});

export default Filter;
